import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
    },
    autocomplete: {},
    inputAdornedEnd: {},
    input: {
      width: '100%',
    },
    searchIcon: {
      fontSize: theme.typography.pxToRem(16),
    },
    resourceMenuItemName: {},
  }),
  { name: 'SelectResourceFileOrUrl' }
);
